import { COOKIE, queryParams } from '@utility/const';
import { removeCookie } from '@utility/cookie';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Button from './Button';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector } from '@hooks/redux';
import * as actions from '../../store/actions';
import { useTranslation } from 'react-i18next';

const CMSPreviewBanner = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const { t } = useTranslation()

  const showCMSPreviewBanner = 
    useSelector(state => state.utils.showCMSPreviewBanner);

  const lang = useSelector(state => state.utils.lang);
  const isAuthenticated = useSelector(state => state.authentication.isAuthenticated)

  useEffect(() => {
    if (showCMSPreviewBanner && lang) {
      updateCMSPreviewBannerHeight();
    }
  }, [showCMSPreviewBanner, lang]);

  useEffect(() => {
    if (showCMSPreviewBanner) {
      window.addEventListener("resize", updateCMSPreviewBannerHeight)
    }
  }, [showCMSPreviewBanner]);

  const updateCMSPreviewBannerHeight = () => {
    let elementHeight = document.getElementById('cms-preview-banner').offsetHeight;
    //console.log('elementHeight', elementHeight)
    if (!elementHeight) {
      elementHeight = 38;
    }
    document.documentElement.style.setProperty('--label-preview-banner-height', elementHeight + 'px');
  }

  const removeCMSPreviewCookie = () => {
    dispatch(actions.setShowCMSPreviewBanner(false))
    removeCookie(COOKIE.CMS_PREVIEW);
    //go to same page without cms preview query parameter
    history.push(location.pathname + location?.search?.replaceAll(`${queryParams.CMS_PREVIEW}=true`,''))
    //refresh page
    history.go(0)
  }

  if (showCMSPreviewBanner) {
    return (
      <div className="label-preview-banner" id="cms-preview-banner">
        <div className="label-preview-banner__container">
          <span>
            {lang?.CMS_PREVIEW_BANNER_TEXT}
          </span>

          <div className="label-preview-banner__ctas">
            <Button handleClick={removeCMSPreviewCookie}>{isAuthenticated ? lang.EXIT : t('EXIT')}</Button>
          </div>
        </div>
      </div>
    )
  }
  return null;
}

export default CMSPreviewBanner;
